module.exports = __webpack_public_path__ + "static/media/Image.117a6d3e.svg";